module.exports = __webpack_public_path__ + "img/icon_pause_2.0622b149.svg";